import styled from 'styled-components';

import { Text } from '@/nova/components/Text/Text';
import { COLORS } from '@/nova/theme/tokens';

/* The single-clip shot list (easy mode): the music line, then one quiet card per timed shot. Understated on
   purpose: hairline cards, a small read-only time chip, and the closing shot tagged where the logo + CTA land. */

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Shots = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Shot = styled.div<{ $closing?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid ${(p) => (p.$closing ? COLORS.accent : COLORS.hairline)};
  background: ${COLORS.surfaceInset};
`;

export const ShotHead = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

/** The read-only time range of a shot (timings are not editable in v2). */
export const TimeChip = styled(Text).attrs({ tag: 'span' as const })`
  flex: 0 0 auto;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid ${COLORS.hairline};
  background: ${COLORS.surfaceCard};
  font-size: 11px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${COLORS.text};
`;

export const ShotLabel = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: ${COLORS.textMuted};
`;

/** The closing shot's note: this is where the logo + CTA are composited. */
export const ClosingTag = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 11px;
  font-weight: 600;
  color: ${COLORS.accent};
`;

/** Camera + sound side by side (they are short lines). Wraps to one column when the pane is narrow. */
export const ShotFields = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 10px;
`;
